import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import Dropdown1 from 'srcReact/components/common2/Dropdown1'
import Button from 'srcReact/components/common2/Button'
import Icon from 'srcReact/components/icons/Icon'

import { profileActions as pa } from '../../../../../../action'
import styles from './styles.module.scss'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'

export default function LanguagePopup({ options }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { profileData } = useSelector((state) => state.myProfile)
  const [error, setError] = useState('')

  const [selectedlanguage, setSelectedlanguage] = useState([])

  useEffect(() => {
    if (profileData.user.languages.length > 0) {
      setSelectedlanguage(profileData.user.languages)
    }
  }, [])

  const handleDone = () => {
    const payload = {
      key: 'languages_code',
      value: selectedlanguage?.length > 0 ? selectedlanguage.map((x) => x.value ?? x.code).join(',') : ''
    }
    dispatch(pa.putProfileDetails(payload.key, payload.value))
    dispatch(pa.setLanguagePopup(false))
  }

  const handleDelete = (lang) => {
    const langCode = lang.value ?? lang.code
    const language = selectedlanguage.filter((l) => l.code !== langCode && l.value !== langCode)
    setSelectedlanguage(language)
  }

  const handleClose = () => {
    dispatch(pa.setLanguagePopup(false))
  }

  const handleSelect = (lang) => {
    setError('')
    const alreadySelectedLanguage = selectedlanguage.find((l) => l.code === lang.value || l.value === lang.value)
    if (alreadySelectedLanguage) {
      setError(t('my_profile.info_block_edit.langAlreadySelected', { language: alreadySelectedLanguage.name }))
    } else {
      setSelectedlanguage([...selectedlanguage, lang])
    }
  }

  return (
    <div className={`${styles.languagePopup}`}>
      <button className={styles.closeWrap} onClick={handleClose}>
        <Icon name='close' styleModifier={styles.closeIcon} />
      </button>
      <h2>{t('my_profile.popup.titleL')}</h2>
      <div className={`${styles.languageSelectionWrap}`}>
        <div className={`${styles.selectWrap}`}>
          <Dropdown1
            value={{
              value: 'default',
              label:
                profileData.user.languages.length === 0
                  ? t('my_profile.info_block_edit.first_language')
                  : t('my_profile.info_block_edit.another_language')
            }}
            isSearchable={true}
            onChange={handleSelect}
            options={options}
            className={styles.dropdown}
            closeMenuOnSelect={true}
          />
        </div>
        {error && <ErrorMessage text={error} className={styles.error} />}
        {selectedlanguage.length > 0 &&
          selectedlanguage.map((lang) => (
            <div className={`${styles.selectWrap}`}>
              <button className={styles.deleteWrap} onClick={() => handleDelete(lang)}>
                <Icon name='close' styleModifier={styles.deleteIcon} />
              </button>
              <div className={styles.selectedOption}>{lang.label || lang.name}</div>
            </div>
          ))}
        <Button customStyle={styles.doneButton} text={t('global.done')} handleClick={handleDone} size='medium' />
      </div>
    </div>
  )
}
